import React from 'react'
import { SvgIcon } from '../svg-icon'
/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.DefaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}
/**
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <ChevronOutlineIcon width={12} />
 */
export const ChevronOutlineIcon = props => (
    <SvgIcon {...props}>
        <path d="M13.06 20.42C12.8623 20.4201 12.6692 20.3611 12.5052 20.2506C12.3413 20.1402 12.2141 19.9832 12.14 19.8L9.82001 14.17L4.19001 11.85C4.00739 11.775 3.85106 11.6476 3.74073 11.4839C3.6304 11.3201 3.57099 11.1274 3.57001 10.93C3.57052 10.7325 3.62847 10.5395 3.73678 10.3743C3.84508 10.2092 3.99908 10.0791 4.18001 10L19.03 3.64C19.2133 3.56272 19.4154 3.54183 19.6105 3.58C19.8057 3.61818 19.9851 3.71368 20.1257 3.8543C20.2663 3.99493 20.3618 4.17429 20.4 4.36946C20.4382 4.56463 20.4173 4.76676 20.34 4.95L13.98 19.8C13.907 19.984 13.7801 20.1417 13.6159 20.2524C13.4518 20.363 13.258 20.4214 13.06 20.42ZM7.16001 10.92L10.97 12.49C11.0914 12.5396 11.2017 12.6129 11.2944 12.7056C11.3871 12.7983 11.4604 12.9086 11.51 13.03L13.08 16.84L17.52 6.48L7.16001 10.92Z" />
    </SvgIcon>
)

ChevronOutlineIcon.defaultProps = defaultProps
